import React, { useEffect, useState } from "react";
import Bar from "./Bar";
import { gregorian_to_jalali } from "../lib/jdate";

const ReformatDate = (date) => {
  let _date = new String(date).split(", ");
  let reverse_date = _date[0].split("/");
  reverse_date = [reverse_date[2], reverse_date[0], reverse_date[1]].join("/");
  if (wck_app.show_hour) {
    return `${reverse_date}, ${_date[1]}`;
  } else return reverse_date;
};

const CalculatePeriodInDays = (start_at, end_at) => {
  start_at = new Date(start_at.replace(/-/g, "/"));
  end_at = new Date(end_at.replace(/-/g, "/"));
  let raw_period = end_at - start_at;
  if (raw_period < 1) return 0;
  else return ~~(raw_period / (24 * 60 * 60 * 1000));
};

const CalculateRemaining = (start_at, end_at) => {
  let total_period = CalculatePeriodInDays(start_at, end_at);
  let remaining_days = ~~(
    (new Date(end_at.replace(/-/g, "/")) - gregorian_to_jalali(new Date())) /
    (24 * 60 * 60 * 1000)
  );
  if (remaining_days < 1) return 0;
  if (remaining_days >= total_period) return 100;
  else return (remaining_days / total_period) * 100;
};

const ResultWrapper = ({ result, backToHome }) => {
  let [remaining, setRemaining] = useState(0);
  useEffect(
    () => setRemaining(~~CalculateRemaining(result.start_at, result.end_at)),
    [result]
  );
  return (
    <div className="warranty-wrapper">
      <div className="nav">
        <svg
          onClick={backToHome}
          className="btn-back"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M14 5l7 7m0 0l-7 7m7-7H3"
          />
        </svg>
        <span className="msg-back">{wck_app.back_button_field}</span>
      </div>
      <section className="lookup-result" id={result.status}>
        <h5>{result.msg}</h5>
        {result.status === "ok" && (
          <div>
            <p>
              {wck_app.product_field}:<b> {result.product}</b>
            </p>
            {/* <p>
              {wck_app.buyer_field}:<b> {result.customer_name}</b>
            </p> */}
            <p>
              {wck_app.start_date_field}:{" "}
              <span dir="ltr">
                <b>
                  {ReformatDate(
                    new Date(
                      result.start_at.replace(/-/g, "/")
                    ).toLocaleString()
                  )}
                </b>
              </span>
            </p>
            {result.end_at != "0000-00-00 00:00:00" &&
              result.end_at != "0000-00-00" && (
                <p>
                  {wck_app.end_date_field}:{" "}
                  <span dir="ltr">
                    <b>
                      {ReformatDate(
                        new Date(
                          result.end_at.replace(/-/g, "/")
                        ).toLocaleString()
                      )}
                    </b>
                  </span>
                </p>
              )}
            {result.agent && (
              <p>
                {wck_app.agent_field}:{" "}
                <b>
                  {" "}
                  {result.agent} / {result.agent_code} / {result.agent_address}
                </b>
              </p>
            )}
          </div>
        )}
      </section>
      {result.end_at != "0000-00-00 00:00:00" &&
        result.end_at != "0000-00-00" &&
        wck_app.is_progress_bar_active && (
          <div className="text-center mt-3">
            <span>{wck_app?.remaining_warranty_time}</span>
            <Bar remaining={remaining} />
          </div>
        )}
    </div>
  );
};

export default ResultWrapper;
